import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { ProtectAPi } from "../../../../api/ProtectAPi";
import AdminQuickNav from "../AdminQuickNav";
import BackButton from "../../../tools/BackButton";

const OrderView = () => {
  const { http } = ProtectAPi();
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH ORDER ================= */
  useEffect(() => {
    http
      .get(`/order-view/${id}`)
      .then((res) => {
        // ✅ Backend plain object পাঠাচ্ছে
        if (res.data && res.data.id) {
          setOrder(res.data);
        } else {
          swal("Error", "Order not found", "error");
          navigate("/admin/order-list");
        }
      })
      .catch(() => {
        swal("Error", "Order not found", "error");
        navigate("/admin/order-list");
      })
      .finally(() => setLoading(false));
  }, [id, navigate]);

  /* ================= LOADING ================= */


  if (!order) return null;

  return (
    <div className="main-content" style={{ marginTop: -20 }}>
      <section className="section">
        <AdminQuickNav active="orders" />

        <div className="card">
          <div className="card-body">

            <div className="d-flex justify-content-between mb-3">
              <h5>Order Details</h5>
              <BackButton />
            </div>

            {/* ================= ORDER INFO ================= */}
            <div className="row">
              <div className="col-md-4 mb-3">
                <label>Order Number</label>
                <input className="form-control" value={order.order_number} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Status</label>
                <input className="form-control" value={order.status} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Payment Status</label>
                <input className="form-control" value={order.payment_status} disabled />
              </div>
            </div>

            <hr />

            {/* ================= PRODUCT INFO ================= */}
            <h6 className="mb-3 fw-bold">Product Information</h6>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Product Name</label>
                <input className="form-control" value={order.product_name} disabled />
              </div>

              <div className="col-md-6 mb-3">
                <label>Article Number</label>
                <input className="form-control" value={order.article_number || "—"} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Color</label>
                <input className="form-control" value={order.color_name || "—"} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Size</label>
                <input className="form-control" value={order.size || "—"} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Quantity</label>
                <input className="form-control" value={order.quantity} disabled />
              </div>
            </div>

            <hr />

            {/* ================= CUSTOMER INFO ================= */}
            <h6 className="mb-3 fw-bold">Customer Information</h6>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Customer Name</label>
                <input className="form-control" value={order.customer_name} disabled />
              </div>

              <div className="col-md-6 mb-3">
                <label>Phone</label>
                <input className="form-control" value={order.phone} disabled />
              </div>

              <div className="col-md-6 mb-3">
                <label>Email</label>
                <input className="form-control" value={order.email || "—"} disabled />
              </div>

              <div className="col-md-6 mb-3">
                <label>District</label>
                <input className="form-control" value={order.district || "—"} disabled />
              </div>

              <div className="col-md-12 mb-3">
                <label>Address</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={order.address}
                  disabled
                ></textarea>
              </div>
            </div>

            <hr />

            {/* ================= PAYMENT SUMMARY ================= */}
            <h6 className="mb-3 fw-bold">Payment Summary</h6>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label>Price</label>
                <input className="form-control" value={`৳ ${order.price}`} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Subtotal</label>
                <input className="form-control" value={`৳ ${order.subtotal}`} disabled />
              </div>

              <div className="col-md-4 mb-3">
                <label>Total</label>
                <input
                  className="form-control fw-bold"
                  value={`৳ ${order.total}`}
                  disabled
                />
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderView;
